import {RewardType} from "../components/profile/profile-referral-rewards.component";
import { LeagueType } from "../components/ranking/league.component";
import { LeaguePlayerStatus } from "../components/ranking/rank-status.component";

export interface NotificationAchievement {
  id: string;
  tag: string;
  label: string;
  xp: number;
  level: number;
  imageUrl: string | null;
  forcedview?: boolean
  date: Date;
}

export interface UserNotification {
  id: string;
  tag: string;
  name: string;
  level: number;
  imageUrl: string | null;
  forcedview?: boolean;
  date: Date;
  text?: string;
  received: boolean;
  payload: any;
  display?: string;
}

export interface PushNotificationConfigItem {
  code: string;
  type: string;
  subType?: string;
  active: boolean;
  label: string;
}

export interface GameResult {
  date: Date;
  weekDay: number;
  weekNumber: number;
  year: number;
  month: number;
  tournamentId: string;
  moneyGain: number;
  xpGain: number;
  investment: number;
  rank: number;
  totalPlayers: number;
}


export interface DiscordRoleInterface {
  name: string;
  id: string;
  icon: string;
  unicodeEmoji: string;
  color?: string;
}

export interface OnboardingTag {
  tag: string;
  value: boolean;
}

export interface UserItem {
  family: string;
  subFamily?: string;
  label: string;
  code: string;
  image1: string;
  metadata?: { value: string };
}

export interface InventoryItem extends UserItem {
  title?: string;
  subtitle?: string;
  description?: string;
}

export interface GroupInventoryItem extends UserItem {
  quantity: number;
}

export interface User {
  _id: string;
  email: string;
  level: string;
  xp: string;
  isCoinbaseAuthorized: boolean;
  isSurvey: boolean;
  account: string;
  firstname?: string;
  lastname?: string;
  pseudo?: string;
  discordPseudo?: string;
  discordRole?: DiscordRoleInterface;
  weekRank?: number;
  previousWeekRank?: number;
  previousWeekFrozenFinalMoneyAmount?: number;
  discordAvatarUrl?: string;
  emailVerified?: boolean;
  web3LoginNonce: number;
  web3LoginPublicAddress: string;
  avatarUrl?: string;
  notificationsAchievements?: NotificationAchievement[];
  notifications?: UserNotification[],
  cityLayout: CityLayout,
  createdAt: Date,
  onBoarding?: OnboardingTag[]
  isPremium: boolean,
  pushNotificationCodes?: PushNotificationConfigItem[];
  gemsAmount: number;
  scoreSnapshotUrl?: string;
  betStreakCount: number;
  cryptoRewards?: CryptoRewardType[];
}

export type CryptoRewardType = {
  amount: number;
  crypto_code: string;
  wallet_public_address: string;
  sent_to_wallet: boolean;
  sent_on: Date;
  created_on: Date;
}

export type UserXpResponse = {
  xp: number;
}

export interface PlayerItem {
  pseudo: string;
  xp: number;
  level?: string;
  rank?: string;
  displayedRank?: string;
  score: number;
  gemsAmount: number;
  discordRole?: DiscordRoleInterface;
  avatarUrl: string;
  userId: string;
  verified: boolean;
  walletStatus?: WalletStatusEnum;
  metadata?: { logo?: string };
  initialInvestment?: number;
  gain: number;
  scoreSnapshotUrl?: string;
  scorePortraitSnapshotUrl?: string;
  previousWeekRank?: number;
  previousWeekFrozenFinalMoneyAmount?: number;
  previousWeekBeneficeAmount?: number;
  league: LeagueType;
  leagueStatus: LeaguePlayerStatus;
  leagueRank: string;
  tournamentNumber?: number;
  gameCategory?: GameCategory;
}

export type PlayerFriend = {
  _id: string,
  pseudo: string,
  gemsAmount: number,
  moneyAmount: number,
  picture: string
}

export interface PlayerListResponse {
  players: Array<PlayerItem>,
  currentPlayer: PlayerItem,
  totalPlayers: number,
  pageIndex?: number,
  week?: string;
}

export interface CityLinkResponse {
  _id: string
}

export interface CityLink {
  url: string
}

export interface Like {
  liked: boolean
}

export interface LikesCount {
  value: number
}

export enum WalletStatusEnum {
  VERIFIED,
  PARTIALLY,
  UNVERIFIED
}

export interface CityLayout {
  _id: string,
  layout: any;
}

export interface ReferralProgram {
  code: string;
  active: boolean;
  shouldStartAt: Date;
  expireAt: Date;
  label?: string;
  description?: string;
  image?: string;
}

export interface ReferralsDatas {
  totalReferredFriends: number,
  lastRewardedStep: number,
  isFan: boolean,
}

export interface DailyQuest {
  claimableDate: Date,
  rewardType: RewardType,
  rewardAmount: number,
  isClaimed: boolean
}

export enum GameCategory {
  INVEST_GAME,
  BET_GAME
}

export enum GameNameType {
  INVEST_GAME = "Invest Game",
  BET_GAME = "Bet Game"
}

export enum GameNameValue {
  "Invest",
  "Bet"
}

export enum TournamentRewardType {
  MASTER_COLLECTIBLE = "master-collectible",
  DIAMOND_COLLECTIBLE = "diamond-collectible",
  PLATINUM_COLLECTIBLE = "platinum-collectible",
  GOLD_COLLECTIBLE = "gold-collectible",
  SILVER_COLLECTIBLE = "silver-collectible",
  BRONZE_COLLECTIBLE = "bronze-collectible",
  CRYPTO = "crypto",
  GEMS = "gems",
  POWER_UP = "power-up"
}

export interface TournamentReward {
  value: number;
  type: TournamentRewardType;
}

export interface LeagueRankReward {
  ranks: number[];
  rewards: TournamentReward[];
}